/** @jsx jsx */

import { Fragment as _, useState, useRef, useEffect, useContext } from 'react';
import { css, jsx, keyframes } from '@emotion/core';
import pubSub from 'services/pubSub';
import { UPDATE_RECTANGLE_HOTSPOT_LOCAL_STATE } from 'components/Editor/EditHotSpotIsolated/EditHotSpotIsolated_v2';

const Rectangle = props => {
  const {
    id,
    name,
    currentHotspotId,
    root,
    inverseScale,
    color,
    points,
    onClick,
  } = props;

  const selected = id === `hotspot-${currentHotspotId}`;

  const [rectState, setRectState] = useState<{
    x: number;
    y: number;
    w: number;
    h: number;
  }>({
    x: 0,
    y: 0,
    w: 0,
    h: 0,
    ...points,
  });

  const drawing = useRef<boolean>(false);
  const startXY = useRef<{ startX: number; startY: number }>({
    startX: 0,
    startY: 0,
  });

  useEffect(() => {
    //
    const pS = pubSub.subscribe(
      `${UPDATE_RECTANGLE_HOTSPOT_LOCAL_STATE}_${id}`,
      points => {
        setRectState(points);
      }
    );

    return () => {
      pS();
    };
  }, []);

  useEffect(() => {
    return;

    if (!root.current) {
      return;
    }

    // if (!selected) {
    //   return;
    // }

    const onMouseDown = e => {
      // console.log(selected);

      if (!selected) {
        return;
      }

      drawing.current = true;
      startXY.current = {
        startX:
          e.clientX - root.current.getBoundingClientRect().left * inverseScale,
        startY:
          e.clientY - root.current.getBoundingClientRect().top * inverseScale,
      };

      setRectState(rectState => ({
        x: 0,
        y: 0,
        w: 0,
        h: 0,
      }));

      root.current.addEventListener('mousemove', onMouseMove);
      root.current.addEventListener('mouseup', onMouseUp);
    };

    const onMouseMove = e => {
      console.log(selected);

      // e.persist();

      if (!selected || !drawing.current) {
        return;
      }

      const { startX, startY } = startXY.current;

      if (!startX || !startY) {
        // return;
      }

      const clientX =
        e.clientX - root.current.getBoundingClientRect().left * inverseScale;
      const clientY =
        e.clientY - root.current.getBoundingClientRect().top * inverseScale;

      const negX = clientX < startX;
      const negY = clientY < startY;

      const x = negX ? Math.abs(clientX) : startX;
      const y = negY ? Math.abs(clientY) : startY;
      const w = Math.abs(clientX - startX);
      const h = Math.abs(clientY - startY);

      setRectState(rectState => ({
        x,
        y,
        w,
        h,
      }));
    };

    const onMouseUp = e => {
      drawing.current = false;

      // console.log('UPDATE_HOTSPOT_POINTS');
      // console.log(rectState);

      setRectState(rectState => {
        pubSub.publish('UPDATE_HOTSPOT_POINTS', {
          x: rectState.x,
          y: rectState.y,
          w: rectState.w,
          h: rectState.h,
        });

        return {
          ...rectState,
        };
      });

      // rectState.current = {};

      root.current.removeEventListener('mousemove', onMouseMove);
      root.current.removeEventListener('mouseup', onMouseUp);
    };

    if (selected) {
      root.current.addEventListener('mousedown', onMouseDown);
    } else {
      root.current.removeEventListener('mousedown', onMouseDown);
      root.current.removeEventListener('mousemove', onMouseMove);
      root.current.removeEventListener('mouseup', onMouseUp);
    }

    // () => {
    //   root.current.removeEventListener('mousedown', onMouseDown);
    //   root.current.removeEventListener('mouseup', onMouseUp);
    //   root.current.removeEventListener('mouseup', onMouseUp);
    // };
  }, [selected]);

  return (
    <rect
      key={`rect${0}`}
      id={id}
      rx={10}
      x={rectState.x}
      y={rectState.y}
      width={rectState.w}
      height={rectState.h}
      style={{
        fill: color,
        transition: 'fill 0.1s',

        cursor: 'pointer',

        pointerEvents: selected ? 'none' : 'auto',
      }}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();

        console.log(e);
        onClick();
      }}
    />
  );

  return (
    <rect
      // transform="scale(-1 1)"
      key={`rect${0}`}
      id={id}
      x={rectState.x}
      y={rectState.y}
      // rx="10"
      width={rectState.w}
      height={rectState.h}
      style={{
        fill: color,
        transition: 'fill 0.1s',
        // transform: `scaleX(${rectState.current.negX ? -1 : 1}) scaleY(${
        //   rectState.current.negY ? -1 : 1
        // })`,

        // transform: 'scaleX(-1)',
        cursor: 'pointer',

        pointerEvents: selected ? 'none' : 'auto',
      }}
      // onMouseDown={e => {
      //   e.stopPropagation();
      //   e.preventDefault();
      // }}
      onClick={e => {
        e.stopPropagation();
        e.preventDefault();

        console.log(e);
        onClick();
      }}
    />
  );
};

export default Rectangle;
